import React, { Component } from "react";
import { connect } from 'react-redux';
import { Spin } from 'antd';
import packages from '../../Actions/packages';
import paymentTransaction from '../../Actions/paymentTransaction';
import Header from '../header';
import Footer from '../Footer';
import PackageItemContainer from "./PackageItemContainer";
import user from '../../Actions/user';
import {pageGA } from '../../Helpers/GoogleAnalytics';
import license from '../../Actions/license'
const { getLicensesHistorical } = license.actions;
const { getPreUserData, getUserInfo } = user.actions;
const { getPackagesData } = packages.actions;
const { getConfigTransaction } = paymentTransaction.actions;

class BuyLicense extends Component {
	componentDidMount() {
		const { email, type } = this.props.match.params;
		let data = { email, idUser: '00000000-0000-0000-0000-000000000000', idDealer: '00000000-0000-0000-0000-000000000000' };
		this.props.getPackagesData(data);
		this.props.getConfigTransaction();
		if(type === 'preUser') {
			this.props.getPreUserData(data.email);
		} else if(type === 'user') {
			this.props.getLicensesHistorical();
			this.props.getUserInfo(data.email);
		}
		pageGA()
	}
	validateFreePlan(packages,licensePagination){
		if(licensePagination !== null && licensePagination !== undefined){
			if(licensePagination.length > 0){
				return packages.filter(w=> w.name.toLowerCase() !== "gratis")
			}else{
				return packages;
			}
		}
		else{
			return packages
		}
	}

	render() {
		let { packages, licensePagination } = this.props;
		let filteredPackages = this.validateFreePlan(packages,licensePagination.items);
		return (
			<React.Fragment>
				<Header
					logo='/img/logo-efisco.png'
				/>
				<div className="buy-license-container">
					<div className="buy-license-header">
						<h2 className="buy-license-title em">¿Listo para conciliar información?</h2>
						<h2 className="buy-license-title">Ahora solo elige el plan que mejor se adapte a tus necesidades</h2>						
					</div>
					<PackageItemContainer packages={filteredPackages} preUserData={this.props.preUserData} userData={this.props.userInfo}/>
				</div>
				<Footer/>
			{
				this.props.packageLoading &&
				<div className="loading-container">
					<Spin size="large" tip="Cargando" />
				</div>
			}
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	let packageLoading = state._genericComponents.loading.find('licenseLoading');
	return {
		packages: state.packages.packagesData,
		packageLoading,
		preUserData: state.user.preUserData,
		userInfo: state.user.userInfo,
		licensePagination: state.license.licensePagination,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getPackagesData(data) {
			dispatch(getPackagesData(data));
		},
		getPreUserData(email) {
			dispatch(getPreUserData(email));
		},
		getConfigTransaction(data) {
			dispatch(getConfigTransaction(data));
		},
		getUserInfo(email) {
			dispatch(getUserInfo(email));
		},
		getLicensesHistorical(data) {
			dispatch(getLicensesHistorical(data));
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyLicense);